import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles, Divider } from '@material-ui/core';
import {
  Header,
  OpenHour,
  ParkingHour,
  Amenities,
  RoutesButton,
  GoNow,
  Buttons,
} from '../../components/index';
import styles from './styles';

const MPInformation = ({ classes, t }) => (
  <React.Fragment>
    <Header
      className={classes.title}
      leftButton="backToDetails"
      rightButton=""
      title={t('mp-information.label.title')}
    />
    <Buttons />
    <OpenHour />
    <div className={classes.content__padding}>
      <Divider />
    </div>
    <ParkingHour />
    <div className={classes.content__padding}>
      <Divider />
    </div>
    <Amenities />
    <div className={classes.content__padding}>
      <Divider />
    </div>
    <div className={classes.footer}>
      <RoutesButton />
      <GoNow />
    </div>
  </React.Fragment>
);

MPInformation.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation()(MPInformation));
